import { formatPrice as o } from "./index110.mjs";
import e from "react";
const s = ({ children: a, isDisabled: t }) => /* @__PURE__ */ e.createElement("span", { className: "inline-block" }, a, /* @__PURE__ */ e.createElement(
  "span",
  {
    className: `text-sm font-semibold ${t ? "text-neutrals-40" : "text-neutrals-90"}`
  },
  " ",
  I18n.t("booking_engine.room.total")
)), i = ({
  price: a,
  currency: t,
  cityTaxIncluded: n = !1,
  isDisabled: r = !1
}) => /* @__PURE__ */ e.createElement(s, { cityTaxIncluded: n, isDisabled: r }, /* @__PURE__ */ e.createElement(
  "span",
  {
    className: `text-lg font-semibold ${r ? "text-neutrals-40" : "text-neutrals-90"}`
  },
  o(parseFloat(a), t, !0)
)), p = ({
  price: a,
  currency: t,
  originalPrice: n,
  cityTaxIncluded: r = !1,
  isDisabled: l = !1
}) => /* @__PURE__ */ e.createElement(s, { cityTaxIncluded: r, isDisabled: l }, /* @__PURE__ */ e.createElement(
  "del",
  {
    "data-testid": "original-price",
    className: `text-[13px] ${l ? "text-danger-30" : "text-danger-50"} font-normal`
  },
  o(parseFloat(n), t, !0)
), " ", /* @__PURE__ */ e.createElement(
  "span",
  {
    "data-testid": "promotion-price",
    className: `text-lg font-semibold ${l ? "text-neutrals-40" : "text-neutrals-90"}`
  },
  o(parseFloat(a), t, !0)
));
export {
  p as PromotionPrice,
  i as StandardPrice
};
